export type KeyboardDndLiveRegionProps = {
  message: string;
  politeness?: 'polite' | 'assertive';
};

/**
 * Screen-reader live region for keyboard drag-and-drop announcements.
 */
export function KeyboardDndLiveRegion({
  message,
  politeness = 'polite',
}: KeyboardDndLiveRegionProps): JSX.Element {
  return (
    <div
      aria-live={politeness}
      aria-atomic="true"
      data-dnd-live-region="true"
      className="sr-only"
    >
      {message}
    </div>
  );
}
